import { useMemo } from "react";
import { useGetPropagationCampaignsQuery } from "@/services/campaign-propagation";
import { Meta } from "src/@types/paginated";
import { IGetPropagationCampaignsParams } from "src/@types/campaign-propagation";

export const usePropagationCampaignsData = (params: IGetPropagationCampaignsParams) => {
  const { data: rawData, isLoading, isFetching, error, refetch } =
    useGetPropagationCampaignsQuery(params);

  const { campaigns, meta } = useMemo(() => {
    if (!rawData) return { campaigns: [], meta: {} as Meta };

    const meta: Meta = {
      currentPage: rawData.pagination.page,
      lastPage: rawData.pagination.totalPages,
      perPage: rawData.pagination.limit,
      total: rawData.pagination.total,
      prev: rawData.pagination.hasPrevious ? rawData.pagination.page - 1 : null,
      next: rawData.pagination.hasNext ? rawData.pagination.page + 1 : null,
    };

    return { campaigns: rawData.data, meta };
  }, [rawData]);

  return { campaigns, meta, isLoading, isFetching, error, refetch };
};